(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-related-products"] && !Shopify.designMode) return;
  try {
    class CartProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        // Parse our comma-separated list of IDs into a real array
        const productIds = this.dataset.ids ? this.dataset.ids.split(',') : [];
        if (productIds.length === 0) return;

        // Recursive function to try fetching recommendations sequentially
        const fetchRecommendations = (index) => {
          if (index >= productIds.length) return; // Stop if we run out of products

          const currentId = productIds[index].trim();
          const requestUrl = `${this.dataset.baseUrl}?section_id=${this.dataset.sectionId}&product_id=${currentId}&limit=${this.dataset.limit}`;

          fetch(requestUrl)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              
              const recommendations = html.querySelector('.product-recommendations') || html.firstElementChild;

              // Check if the HTML returned actually contains visible product items inside the list
              const hasProducts = recommendations && recommendations.querySelector('ul.grid li.grid__item');

              if (hasProducts && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              } else {
                // No recommendations found for this product, try the next one in the cart array
                fetchRecommendations(index + 1);
              }
            })
            .catch(e => {
              console.error(e);
              // Fallback to the next product if an error occurs
              fetchRecommendations(index + 1);
            });
        };

        // Start checking from the first item (Index 0)
        fetchRecommendations(0);
      };

      const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
      observer.observe(this);
    }
  }

  if (!customElements.get('cart-product-recommendations')) {
    customElements.define('cart-product-recommendations', CartProductRecommendations);
  }
  } catch(e) { console.error(e); }
})();

})();
